import React from 'react';

import WechatMobProcess from 'app/components/OrderPayment/Wechat/WechatMobProcess';

const WechatPaymentMob = () => {
  return <WechatMobProcess />;
};

export default WechatPaymentMob;
